import React from "react";
import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";
import PageNotFound from "../shared/presentations/PageNotFound";
import ForgotPasswordContainer from "./containers/ForgotPasswordContainer";
import SetPasswordContainer from "./containers/SetPasswordContainer";
import SignInContainer from "./containers/SignInContainer";
import SignUpContainer from "./containers/SignUpContainer";

export const AuthRoutes = () => {
  const match = useRouteMatch();
  return (
    <Switch>
      <Route path={match.path + "/signup"} ><SignUpContainer /></Route>
      <Route path={match.path + "/signin"} ><SignInContainer /></Route>
      <Route path={match.path + "/forgot-password"} ><ForgotPasswordContainer /></Route>
      <Route path={match.path + "/set-password"} ><SetPasswordContainer /></Route>
      <Redirect path={match.path + '/'} exact={true} to={match.path + '/signin'} />
      <Route ><PageNotFound /></Route>
    </Switch>
  );
};